import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'
import DateTimeLocal from './filters/DateTimeLocal'
//import { DateTime } from "luxon";

import '@mdi/font/css/materialdesignicons.css'


Vue.config.productionTip = false

Vue.filter('DateTimeLocal', DateTimeLocal );

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
